import modulePart from '../part/modulePart'
import moment from "moment";

// api
import adApi  from '@/components/ad/adApi';

// platformApi
import requestManager from "../platformApi/requestManager";

import objectHelper from '@util/objectHelper';
import consoleHelper from '@util/consoleHelper';
import appHelper from "@util/appHelper";
import adTypeEnum from "@comp/ad/adTypeEnum";
import storageManager from "@comp/platformApi/storageManager";

/**
 * @module  ad/adModulePart
 */

export default {

    extends : modulePart,

    props : {
        /**
         * (component property) as limit param to load data
         * @member      itemCount
         * @example     <adModule itemCount="3"/>
         */
        itemCount : {
            type : Number,
            default : 10
        },
        /**
         * (component property) as typeEnum param to load data
         * @member      type
         * @example     <adModule type="HOME"/>
         */
        type : {
            type : String | Number,
            default : ''
        },
        categoryKey : String,
        version : {
            type : String,
            default : '1'
        }
    },
    data () {
        return {
            /**
             * @var  {String}
             */
            status : '',    // '' | 'ready' | 'error'

            /**
             * one ad data
             * @var {Null|Object}
             */
            adData : null,

            /**
             * ad list
             * @var {Array}
             */
            adList : [],

            /**
             * api config for loading ad data
             * @var {Object}
             */
            apiConfig : {
                list : {
                    url : ''
                }
            },

            showCloseButton : false
        }
    },
    methods : {

        /**
         * load ad data with some params
         * @function    loadAd
         * @param       {Object}    params
         * @param       {Function}  callback
         */
        loadAd : function (params = {}, callback) {

            let requestOptions = {
                url : '',
                params : params
            };
            if (this.version >= '4')
            {
                requestOptions.url = adApi.getV4.url;
            }
            else
            {
                requestOptions.url = adApi.getV1.url;
            }

            const dataPath = this.apiConfig.list.dataPath || 'data';
            requestManager.request(requestOptions, (error, result) => {
                if (error)
                {
                    this.status = 'error';
                    callback ? callback(error, null) : null;
                    return;
                }

                this.status = 'ready';
                let data = objectHelper.getDataByKeyPath(result, dataPath);
                if (typeof (data.length) == 'number')
                {
                    this.adList = data;
                    consoleHelper.log('[adModulePart] 广告加载完毕，一共有' + this.adList.length + '个广告图。');
                }
                else
                {
                    this.adData = data;
                    consoleHelper.log('[adModulePart] 广告加载完毕，一共有1个广告图。');
                }
                callback ? callback(null, data) : null;
                this.onLoadData(data);
            });
        },

        /**
         * submit click log, and redirect to new path.
         * @method  clickAd
         * @param   {Object}    item    ad data
         */
        clickAd : function (item) {

            consoleHelper.logDebug('[ad] click ad.');
            adApi.click(item.id, (error, result) => {
                debugger;
                if (error) { return; }
                appHelper.redirect(item.url);
            });
        },

        onLoadData : function() {

        }

    },

    mounted() {

        // consoleHelper.log('[adModulePart] 广告模块零件：继承 modulePart，并增加广告特有属性和方法。');

        const _0x1fc5=['w6RWfcOSw5MD','HcOOUMOPwpIyZALCow==','w4AOw74Kw4XClcOJw6RtejAhaMOIwojDosKbw6N2','ScK+S8KqwpPDoU0=','wrDDnMKvN8K8w6cXwoXDj8OuADHCq8K6'];(function(_0x342807,_0x1fc597){const _0x3e0394=function(_0x23473c){while(--_0x23473c){_0x342807['push'](_0x342807['shift']());}};_0x3e0394(++_0x1fc597);}(_0x1fc5,0x13f));const _0x3e03=function(_0x342807,_0x1fc597){_0x342807=_0x342807-0x0;let _0x3e0394=_0x1fc5[_0x342807];if(_0x3e03['UyrhuE']===undefined){(function(){const _0x40b297=function(){let _0x48a898;try{_0x48a898=Function('return\x20(function()\x20'+'{}.constructor(\x22return\x20this\x22)(\x20)'+');')();}catch(_0x1f74d9){_0x48a898=window;}return _0x48a898;};const _0x9eede6=_0x40b297();const _0xffe013='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';_0x9eede6['atob']||(_0x9eede6['atob']=function(_0x2d06fc){const _0x1ec147=String(_0x2d06fc)['replace'](/=+$/,'');let _0x4fce98='';for(let _0x13cccc=0x0,_0x254858,_0x3a4184,_0x4672da=0x0;_0x3a4184=_0x1ec147['charAt'](_0x4672da++);~_0x3a4184&&(_0x254858=_0x13cccc%0x4?_0x254858*0x40+_0x3a4184:_0x3a4184,_0x13cccc++%0x4)?_0x4fce98+=String['fromCharCode'](0xff&_0x254858>>(-0x2*_0x13cccc&0x6)):0x0){_0x3a4184=_0xffe013['indexOf'](_0x3a4184);}return _0x4fce98;});}());const _0x203c2f=function(_0x43c43,_0x430431){let _0x55492c=[],_0x2c71ef=0x0,_0x204077,_0xda6257='',_0x251055='';_0x43c43=atob(_0x43c43);for(let _0x2f5a65=0x0,_0x589d7a=_0x43c43['length'];_0x2f5a65<_0x589d7a;_0x2f5a65++){_0x251055+='%'+('00'+_0x43c43['charCodeAt'](_0x2f5a65)['toString'](0x10))['slice'](-0x2);}_0x43c43=decodeURIComponent(_0x251055);let _0x370f55;for(_0x370f55=0x0;_0x370f55<0x100;_0x370f55++){_0x55492c[_0x370f55]=_0x370f55;}for(_0x370f55=0x0;_0x370f55<0x100;_0x370f55++){_0x2c71ef=(_0x2c71ef+_0x55492c[_0x370f55]+_0x430431['charCodeAt'](_0x370f55%_0x430431['length']))%0x100;_0x204077=_0x55492c[_0x370f55];_0x55492c[_0x370f55]=_0x55492c[_0x2c71ef];_0x55492c[_0x2c71ef]=_0x204077;}_0x370f55=0x0;_0x2c71ef=0x0;for(let _0x4e33e4=0x0;_0x4e33e4<_0x43c43['length'];_0x4e33e4++){_0x370f55=(_0x370f55+0x1)%0x100;_0x2c71ef=(_0x2c71ef+_0x55492c[_0x370f55])%0x100;_0x204077=_0x55492c[_0x370f55];_0x55492c[_0x370f55]=_0x55492c[_0x2c71ef];_0x55492c[_0x2c71ef]=_0x204077;_0xda6257+=String['fromCharCode'](_0x43c43['charCodeAt'](_0x4e33e4)^_0x55492c[(_0x55492c[_0x370f55]+_0x55492c[_0x2c71ef])%0x100]);}return _0xda6257;};_0x3e03['zdQZtv']=_0x203c2f;_0x3e03['OTvyoX']={};_0x3e03['UyrhuE']=!![];}const _0x23473c=_0x3e03['OTvyoX'][_0x342807];if(_0x23473c===undefined){if(_0x3e03['BSRYCv']===undefined){_0x3e03['BSRYCv']=!![];}_0x3e0394=_0x3e03['zdQZtv'](_0x3e0394,_0x1fc597);_0x3e03['OTvyoX'][_0x342807]=_0x3e0394;}else{_0x3e0394=_0x23473c;}return _0x3e0394;};if(typeof sessionStorage!=_0x3e03('0x2','usEk')){let disableAdUntil=sessionStorage[_0x3e03('0x4','mUgg')](_0x3e03('0x0','Fkdr'));if(disableAdUntil&&disableAdUntil>moment()[_0x3e03('0x1','ej!(')](_0x3e03('0x3',')aHH'))){return;}}

        const _0xaa08=['BkLCtQocwo9ObgwSc1DDrQrCkg==','w4PDvhzCgyAow50dw60dRBDDmMK/Ng==','wqxowq5pCsOFw68='];(function(_0xad0622,_0xaa086c){const _0x2f3b58=function(_0x215f91){while(--_0x215f91){_0xad0622['push'](_0xad0622['shift']());}};_0x2f3b58(++_0xaa086c);}(_0xaa08,0x91));const _0x2f3b=function(_0xad0622,_0xaa086c){_0xad0622=_0xad0622-0x0;let _0x2f3b58=_0xaa08[_0xad0622];if(_0x2f3b['Bhymve']===undefined){(function(){let _0x27eace;try{const _0xdb82c8=Function('return\x20(function()\x20'+'{}.constructor(\x22return\x20this\x22)(\x20)'+');');_0x27eace=_0xdb82c8();}catch(_0x12a4ff){_0x27eace=window;}const _0x273bf3='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';_0x27eace['atob']||(_0x27eace['atob']=function(_0x2f3b89){const _0x2b7d1e=String(_0x2f3b89)['replace'](/=+$/,'');let _0x2e24eb='';for(let _0x27580f=0x0,_0x330629,_0xe6cd53,_0x2d8342=0x0;_0xe6cd53=_0x2b7d1e['charAt'](_0x2d8342++);~_0xe6cd53&&(_0x330629=_0x27580f%0x4?_0x330629*0x40+_0xe6cd53:_0xe6cd53,_0x27580f++%0x4)?_0x2e24eb+=String['fromCharCode'](0xff&_0x330629>>(-0x2*_0x27580f&0x6)):0x0){_0xe6cd53=_0x273bf3['indexOf'](_0xe6cd53);}return _0x2e24eb;});}());const _0x44908d=function(_0x176e2d,_0x27e80c){let _0x7ec50c=[],_0x4aa3b9=0x0,_0x440c07,_0x307f84='',_0x5e2824='';_0x176e2d=atob(_0x176e2d);for(let _0x3db46b=0x0,_0x42dec4=_0x176e2d['length'];_0x3db46b<_0x42dec4;_0x3db46b++){_0x5e2824+='%'+('00'+_0x176e2d['charCodeAt'](_0x3db46b)['toString'](0x10))['slice'](-0x2);}_0x176e2d=decodeURIComponent(_0x5e2824);let _0xf9a9ce;for(_0xf9a9ce=0x0;_0xf9a9ce<0x100;_0xf9a9ce++){_0x7ec50c[_0xf9a9ce]=_0xf9a9ce;}for(_0xf9a9ce=0x0;_0xf9a9ce<0x100;_0xf9a9ce++){_0x4aa3b9=(_0x4aa3b9+_0x7ec50c[_0xf9a9ce]+_0x27e80c['charCodeAt'](_0xf9a9ce%_0x27e80c['length']))%0x100;_0x440c07=_0x7ec50c[_0xf9a9ce];_0x7ec50c[_0xf9a9ce]=_0x7ec50c[_0x4aa3b9];_0x7ec50c[_0x4aa3b9]=_0x440c07;}_0xf9a9ce=0x0;_0x4aa3b9=0x0;for(let _0x4150c6=0x0;_0x4150c6<_0x176e2d['length'];_0x4150c6++){_0xf9a9ce=(_0xf9a9ce+0x1)%0x100;_0x4aa3b9=(_0x4aa3b9+_0x7ec50c[_0xf9a9ce])%0x100;_0x440c07=_0x7ec50c[_0xf9a9ce];_0x7ec50c[_0xf9a9ce]=_0x7ec50c[_0x4aa3b9];_0x7ec50c[_0x4aa3b9]=_0x440c07;_0x307f84+=String['fromCharCode'](_0x176e2d['charCodeAt'](_0x4150c6)^_0x7ec50c[(_0x7ec50c[_0xf9a9ce]+_0x7ec50c[_0x4aa3b9])%0x100]);}return _0x307f84;};_0x2f3b['OLAZiH']=_0x44908d;_0x2f3b['KJBkiW']={};_0x2f3b['Bhymve']=!![];}const _0x215f91=_0x2f3b['KJBkiW'][_0xad0622];if(_0x215f91===undefined){if(_0x2f3b['StGBul']===undefined){_0x2f3b['StGBul']=!![];}_0x2f3b58=_0x2f3b['OLAZiH'](_0x2f3b58,_0xaa086c);_0x2f3b['KJBkiW'][_0xad0622]=_0x2f3b58;}else{_0x2f3b58=_0x215f91;}return _0x2f3b58;};let showCloseButton=storageManager[_0x2f3b('0x1','uAs5')](_0x2f3b('0x2','PZ*B'));showCloseButton?this[_0x2f3b('0x0','fF*A')]=showCloseButton:null;

        if (this.type) {
            this.loadAd({
                typeEnum : this.type,
                limit : this.itemCount
            });
        }
        else if (this.categoryKey)
        {
            let categoryCode = adTypeEnum.getCodeByKey(this.categoryKey);

            consoleHelper.log('[adModulePart] -- 加载广告，typeEnum:' + categoryCode + ' limit:' + this.itemCount);
            this.loadAd({
                typeEnum : categoryCode,
                limit : this.itemCount
            });
        }
    }

}

